import { Box, Text } from '@bechtel/gds';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { fullHDScreenWidth, headerHeight, sideBarExpandedWidth, sideBarWidth } from '~/utilities';

interface ContainerBoxStyledProps {
  selectedItem: boolean;
}

interface TextFieldStyledProps {
  applyPermissions: boolean;
}

interface NavigationStyledProps {
  hideBackIcon?: boolean;
}
interface NavLinkStyledProps {
  disabled?: boolean;
}

export const NavLinkStyled = styled(NavLink)<NavLinkStyledProps>`
  ${({ disabled }) => css`
    pointer-events: ${disabled ? 'none' : 'auto'};
  `}
  text-decoration: none;
`;

export const ContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: ${sideBarWidth}px;
  flex-shrink: 0;
  @media only screen and (min-width: ${fullHDScreenWidth}) {
    width: ${sideBarExpandedWidth}px;
  }
`;

export const BackSectionStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  gap: { sm: '300' },
  pl: { sm: '500' },
  py: { sm: '500' },
})`
  ${({ theme }) => css`
    height: ${headerHeight}px;
    box-shadow: ${theme.componentStyles.boxShadow};
  `}
`;
export const NavigationStyled = styled.div<NavigationStyledProps>`
  ${({ theme, hideBackIcon }) => css`
    border-right: 1px solid ${theme.colors.grey[200]};
    overflow-y: auto;
    height: ${hideBackIcon ? `calc(100vh - ${headerHeight}px)` : `calc(100vh - ${2 * headerHeight}px)`};
  `}
`;

export const StatusIndicatorAreaStyled = styled(Box).attrs({
  pt: { sm: '200' },
})`
  position: absolute;
  right: 0;
`;

export const ContainerBoxStyled = styled(Box)<ContainerBoxStyledProps>`
  cursor: pointer;
  position: relative;
  ${({ theme, selectedItem }) => css`
    background-color: ${selectedItem ? theme.colors.primary[100] : ''};
    border-left: ${selectedItem ? `3px solid ${theme.colors.primary[500]}` : `3px solid transparent`};
  `}
`;

export const StatusIndicatorStyled = styled.div<ContainerBoxStyledProps>`
  ${({ theme, selectedItem }) => css`
    width: ${theme.spacings[400]};
    height: ${theme.spacings[400]};
    border-radius: ${theme.radii[900]};
    border: 1px solid ${selectedItem ? theme.colors.grey[300] : theme.colors.primary[500]};
    background-color: ${selectedItem ? 'transparent' : theme.colors.primary[500]};
  `}
`;

export const TextStyled = styled(Text)<TextFieldStyledProps>`
  ${({ applyPermissions }) => css`
    opacity: ${applyPermissions && `0.4`};
  `}
`;
